export default "__VITE_ASSET__CmpWmysZ__"